import type { StockMovementWithArticle } from "@/hooks/queries/useStockMovements";
import { formatDateTime, formatMovementReference } from "../stock-formatters";
import { MobileFact } from "./StockDetailPrimitives";
import { StockMovementBadge } from "./StockBadges";

interface StockMovementGridProps {
  movements: StockMovementWithArticle[];
  onSelect: (movement: StockMovementWithArticle) => void;
}

export function StockMovementGrid({ movements, onSelect }: StockMovementGridProps) {
  if (movements.length === 0) {
    return (
      <div className="rounded-lg border border-border bg-card px-4 py-8 text-center text-[12px] text-muted-foreground">
        Aucun mouvement de stock.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3">
      {movements.map((movement) => (
        <button
          key={movement.id}
          type="button"
          className="rounded-lg border border-border bg-card p-3 text-left"
          onClick={() => onSelect(movement)}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="truncate text-[13px] font-semibold text-foreground">
                {movement.article?.name ?? `Article #${movement.articleId}`}
              </p>
              <p className="mt-0.5 text-[11px] text-muted-foreground">
                Mouvement #{movement.id} - {formatDateTime(movement.createdAt)}
              </p>
            </div>
            <StockMovementBadge type={movement.type} />
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2 border-t border-border pt-3 text-[11px]">
            <MobileFact
              label="Quantité"
              value={`${movement.quantity} ${movement.article?.unit ?? ""}`}
            />
            <MobileFact label="Agent" value={`#${movement.agentId}`} />
            <MobileFact label="Référence" value={formatMovementReference(movement)} />
            <MobileFact
              label="Sortie forcée"
              value={movement.isNegativeOverride ? "Oui" : "Non"}
              danger={movement.isNegativeOverride}
            />
          </div>
        </button>
      ))}
    </div>
  );
}
